import { render, staticRenderFns } from "./SonD.vue?vue&type=template&id=19fa7085&"
import script from "./SonD.vue?vue&type=script&lang=js&"
export * from "./SonD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports